<template>
    <a v-if="isValid" :href="websiteLink" :target="openNewPage ? '_blank' : ''">
        <slot>
            {{ website }}
        </slot>
    </a>
    <span v-else class="disabled" :class="{ 'text-danger': !isValid }">
        {{ website }}
        <span v-if="!isValid">*</span>
    </span>
</template>

<script>
export default {
    name: 'vx-web-link',
    props: {
        href: {
            type: String
        },
        openNewPage: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        websiteLink() {
            if (!this.href) {
                return null
            }
            if (this.href.startsWith('http')) {
                return this.website
            }
            return `//${this.website}`
        },
        website() {
            return this.href || 'No link'
        },
        isValid() {
            try {
                new URL(this.href)
                return true
            } catch (_) {
                return false
            }
        }
    }
}
</script>

<style></style>
